import i18n from '@/locales'
import { providerOptionsMap } from '../constants'

export const getProviderTableColumn = () => {
  return {
    field: 'provider',
    title: i18n.t('bastionHost.provider'),
    minWidth: 100,
    slots: {
      default: ({ row }, h) => {
        return [
          <div class={'d-flex align-items-center'}>
            <img title={row.provider} src={require('./' + row.provider + '.png')} style={{ height: '16px' }} />
            <span class={'ml-1'}>{providerOptionsMap[row.provider].label || row.provider}</span>
          </div>,
        ]
      },
    },
  }
}

export const getAccessUrl = () => {
  return {
    field: 'access_url',
    title: i18n.t('bastionHost.access_url'),
  }
}
